import React from 'react'
import { useTranslation } from 'react-i18next'

import { BILLING_CYCLE } from '../../constants'
import IconActiveUntil from '../../../../svg/iconActiveUntil.svg'
import { IconSelect } from '../../../../svg'

export const ActiveSectionDesktop = ({
    undoDowngrade,
    cancelSubscription,
    productForDowngrade,
    recurringEnabled,
    billingCycleValue,
    subscriptionStatus,
    formattedExpirationDate,
    selected,
}) => {
    const { t } = useTranslation()
    return (
        <div className="subscriptions__state__item-icon-value subscriptions__state__status">
            {productForDowngrade || (!recurringEnabled && billingCycleValue === BILLING_CYCLE.month) ? (
                <>
                    <img className="payment" src={IconActiveUntil} alt="" />
                    <div>
                        <span className="subscriptions__state__item-active-until-value">
                            {`${subscriptionStatus} ${t('Until')} ${formattedExpirationDate}`}
                        </span>
                        <div style={{ display: 'flex', marginTop: '4px' }}>
                            <div className="subscriptions__cancelled">{t('_common.cancelled')}</div>
                            <div className="subscriptions__undo" onClick={undoDowngrade}>
                                {t('Undo')}
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <IconSelect style={{ width: '32px', height: '32px' }} />
                    <div>
                        <span className="subscriptions__state__item-active-value">{subscriptionStatus}</span>
                        {selected && recurringEnabled ? (
                            <div className="subscriptions__cancel" onClick={cancelSubscription}>
                                {t('_pages._billing_and_payments.cancel_subscription')}
                            </div>
                        ) : (
                            <div className="subscriptions__until">
                                {t('Until')} {formattedExpirationDate}
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    )
}
